import { useState } from 'react'

import Modal from '@components/Modal'

import VehicleForm from 'dashboard-vehicles/components/VehicleForm'
import Button from '@components/Button'
import { withTranslate } from '@i18n/utils'
import { sendAmplitudeEvent, useSendGTAGEvent } from 'analytics/utils'

const VehicleFormModalComponent = ({ btnType = 'icon', analyticsFlowType }) => {
    const [open, setOpen] = useState(false)
    const sendGTAGEvent = useSendGTAGEvent()
    const closeModal = () => {
        const modals = document.getElementsByClassName('modal-dropdown')
        if (modals.length === 1) {
            setOpen(false)
        }
    }

    const getButtonProps = btnType => {
        if (btnType === 'outline') {
            return {
                btnStyle: 'outline',
                buttonSize: 'large',
                onClick: () => setOpen(true),
                children: <T>dashboard.vehicles.add.label</T>,
            }
        }
        return {
            btnStyle: 'link',
            buttonSize: 'small',
            className: 'ml-0 booking__select__button',
            iconLeft: 'plus-round',
        }
    }

    const onAddVehicleClick = () => {
        setOpen(true)
        if (analyticsFlowType) {
            sendGTAGEvent('add_vehicle', { flow_type: analyticsFlowType })
            sendAmplitudeEvent('Add Vehicle', { 'Flow type': analyticsFlowType })
        }
    }

    return (
        <>
            <Button {...getButtonProps(btnType)} onClick={onAddVehicleClick}>
                <T>dashboard.vehicles.add.label</T>
            </Button>
            {open && (
                <Modal size="large" onClose={closeModal} header={<T>dashboard.vehicles.add.label</T>}>
                    <VehicleForm onSuccess={() => setOpen(false)} />
                </Modal>
            )}
        </>
    )
}

const VehicleFormModal = withTranslate(VehicleFormModalComponent)

VehicleFormModal.propTypes = {
    btnType: PropTypes.oneOf(['outline', 'icon']),
}

export default VehicleFormModal
